import React from 'react';
import './NosotrosPage.css';

const NosotrosPage =() => (
    <div className="nosotros-page">
        <div className="nosotros-image-container">
            <img className="nosotros-image" src="/assets/nosotros.webp" alt="Nuestro equipo"/>
            <p className="nosotros-description">
                Navi nació de la necesidad urgente que enfrentaban las empresas:
                la falta de integración de tecnologías de inteligencia artificial en sus procesos diarios.
                Detectamos que muchas organizaciones perdían competitividad al no adoptar estas herramientas,
                y decidimos transformar esa carencia en una oportunidad.
                Nuestro origen también está marcado por la ambición de poner en práctica el conocimiento y
                la experiencia de un equipo multidisciplinario, con habilidades técnicas sólidas y
                competencias humanas que nos permiten entender, acompañar y potenciar a cada cliente.

            </p>
            <p className="nosotros-description">
                Hoy, hemos trabajado junto a diversas empresas, escuchando de cerca sus retos y analizando sus necesidades reales.
                Esto nos ha permitido diseñar soluciones a medida que incrementan la productividad y
                preparan a nuestros clientes para estar siempre un paso adelante en la adopción de tecnologías
                emergentes en inteligencia artificial. Nuestra labor no solo consiste en implementar, sino en
                crear herramientas que realmente se adapten a la dinámica y los objetivos de cada organización.
            </p>
            <p className="nosotros-description">
                Miramos hacia adelante con la visión de consolidarnos como una empresa líder en consultoría
                e implementación de tecnologías de inteligencia artificial.
                Aspiramos a ofrecer un portafolio robusto y flexible que cubra las distintas necesidades de
                nuestros clientes, acompañándolos en su evolución digital y posicionándonos como aliados
                estratégicos en su transformación. Nuestro futuro está marcado por la innovación,
                la confianza y la convicción de que la inteligencia artificial es un motor clave
                para el crecimiento empresarial.
            </p>
        </div>
        <div className="team-member">
            <img className="member-image" src="/assets/juanma_miembro.jpg" alt="Nuestro equipo"/>
            <div className="the-member">
                <b className="member-tittle">
                    JUAN MANUEL ZAMBRANO - CEO & CO-FUNDADOR
                </b>
                <p className="member-tittle">
                    Diseñador Industrial - M. en Ingeniería de Organización y logística.
                </p>
                <p className="member-description">
                    Mi misión es convertir la visión en estrategia y la inteligencia artificial en soluciones reales,
                    accesibles e innovadoras que generen impacto positivo en personas y empresas.
                </p>
            </div>

        </div>
        <div className="team-member">
            <img className="member-image" src="/assets/jd_miembro.jpg" alt="Nuestro equipo"/>
            <div className="the-member">
                <b className="member-tittle">
                    JUAN DIEGO ESPINOSA – COO & CO-FUNDADOR
                </b>
                <p className="member-tittle">
                    Ing. Mecánico - M. en Ingeniería de Organización y Logística
                </p>
                <p className="member-description">
                En Navi mi propósito es transformar la complejidad en soluciones simples y accesibles,
                    convirtiendo ideas en proyectos reales que permitan a las empresas hacer más con menos.
                </p>
            </div>

        </div>
        <div className="team-member">
            <img className="member-image" src="/assets/franco_miembro.jpeg" alt="Nuestro equipo"/>
            <div className="the-member">
                <b className="member-tittle">
                    FRANCO STEFANO GINER VASQUEZ – CTO
                </b>
                <p className="member-tittle">
                    Ing. Informático
                </p>
                <p className="member-description">
                Mi objetivo es volver realidad cada idea y meta propuesta con ayuda de la tecnología. Evolucionando y adaptándome al cambio constante que hay en esta industria.
                </p>
            </div>
        </div>
    </div>

);
export default NosotrosPage